import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5c0a5c51"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-heart" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "auth-group"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-right-to-bracket" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user-plus" }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "auth-group"
}
const _hoisted_7 = { class: "auth-item user-trigger" }
const _hoisted_8 = { class: "username" }
const _hoisted_9 = { class: "user-header" }
const _hoisted_10 = { class: "user-info" }
const _hoisted_11 = { class: "name" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user-shield" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-right-from-bracket" }, null, -1))

import { ref, onMounted, watch, computed } from "vue";
import store from "@/store/index";
import { useRouter } from "vue-router";
import commons from "@/utils/Common";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserInforClient',
  setup(__props) {

const router = useRouter();
const tagName = ref("");
const url = ref("");

const isNotLogin = ref(false);
const isLogin = ref(false);
const logOut = async () => {
  commons.logOut()
  await loadData()
  router.push({ path: "./" });
};

const isLoadLogin = computed(() => {
  return store.getters.isLoadLogin;
});
const changePassword = async () => {
  router.push({ path: "/password" });
};
onMounted(async () => {
  await loadData()
});

const loadData = () => {
  let user = commons.getUserData();
  if (user != null && user != undefined) {
    tagName.value = user.tagName;
    url.value = user.avatar;
  }
  else {
    isNotLogin.value = true
    isLogin.value = false
  }
  isLogin.value = commons.checkLogin()
}

watch(isLoadLogin, async (newValue, oldValue) => {
  await loadData()
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/favourite",
      class: "auth-item"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('text.favourite')), 1)
      ]),
      _: 1
    }),
    (!isLogin.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/login",
            class: "auth-item"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('loginForm.login')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/registers",
            class: "auth-item"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('loginForm.register')), 1)
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_a_dropdown, { placement: "bottomRight" }, {
            overlay: _withCtx(() => [
              _createVNode(_component_a_menu, { class: "user-menu" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, { key: "user" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_a_avatar, {
                          size: 36,
                          src: url.value
                        }, null, 8, ["src"]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(tagName.value), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_divider),
                  _createVNode(_component_a_menu_item, {
                    key: "changePass",
                    onClick: changePassword
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('text.changePass')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, {
                    key: "logout",
                    danger: "",
                    onClick: logOut
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('loginForm.logout')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_a_avatar, {
                  size: 28,
                  src: url.value
                }, null, 8, ["src"]),
                _createElementVNode("span", _hoisted_8, _toDisplayString(tagName.value), 1)
              ])
            ]),
            _: 1
          })
        ]))
  ]))
}
}

})